import { render } from "./dreamvacationsection.vue?vue&type=template&id=e586f1fa"
import script from "./dreamvacationsection.vue?vue&type=script&lang=js"
export * from "./dreamvacationsection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__